import { useContext } from 'react';
import AppointmentDisplay from './AppointmentDisplay';
import NoAppointments from './AppointmentDisplay/NoAppointments';
import { SchedulingContext } from '../../scenes/Form/ScheduleAppointmentPage/SchedulingContext';

const PrevisitScheduleAppointment: React.FC = () => {
  const { availableEhrTimeSlots } = useContext(SchedulingContext);

  return (
    <>
      {availableEhrTimeSlots.length ? (
        <AppointmentDisplay />
      ) : (
        <NoAppointments />
      )}
    </>
  );
};

export default PrevisitScheduleAppointment;
